<template>
  <div class="inventoryCount-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "inventoryCountBase",
};
</script>
